import React, {useState} from 'react';

import {Button} from '../../../Button/Button';
import {SingleImageLightbox} from '@wandb/weave/components/PagePanelComponents/LightboxImage';

type CellValueImageProps = {
  value: string;
};

export const CellValueImage = ({value}: CellValueImageProps) => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const onClick = () => setLightboxOpen(true);

  const btn = (
    <Button
      variant="ghost"
      size="small"
      icon="photo"
      tooltip="Click to view"
      onClick={onClick}
    />
  );

  if (!lightboxOpen) {
    return btn;
  }

  return (
    <>
      {btn}
      <SingleImageLightbox
        src={value}
        open={lightboxOpen}
        onClose={() => setLightboxOpen(false)}
      />
    </>
  );
};
